<template>
    <div class="container" id="menu">
        <b-navbar toggleable="md" type="light">
            <b-nav-toggle class="mb-3" label="Exibir/Esconder Menu" target="navbarNav">
                <icon name="bars" style="color: #FFF;" scale="2"></icon>
            </b-nav-toggle>
            <b-collapse is-nav id="navbarNav">
                <b-nav is-nav-bar>
                    <li class="nav-item">
                        <router-link class="nav-link" to="/quem-somos">Quem Somos</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" to="/produtos">Produtos</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" to="/seja-um-parceiro" exact>Seja um parceiro</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" to="/novidades">Novidades</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link class="nav-link" to="/contato">Contato</router-link>
                    </li>
                    <!--<li class="nav-item d-xl-none d-lg-none d-md-none d-sm-block float-right">-->
                    <!--<router-link class="nav-link" to="/seja-um-parceiro/acesso">Acesso Parceiro-->
                    <!--<icon name="user-circle-o" scale="1"></icon>-->
                    <!--</router-link>-->
                    <!--</li>-->
                </b-nav>
            </b-collapse>
        </b-navbar>
    </div>
</template>

<script>
    export default {
        name: 'menu-header'
    }
</script>


// WEBPACK FOOTER //
// Menu.vue?404e1386